import { render, staticRenderFns } from "./RightContent-mf.vue?vue&type=template&id=21538d1e&scoped=true&"
import script from "./RightContent-mf.vue?vue&type=script&lang=js&"
export * from "./RightContent-mf.vue?vue&type=script&lang=js&"
import style0 from "./RightContent-mf.vue?vue&type=style&index=0&id=21538d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21538d1e",
  null
  
)

export default component.exports